import { Button } from "./Button";
import { Modal } from "./Modal";

interface Props {
  open: boolean;
  title?: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  destructive?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmDialog({
  open, title = "Confirmar",
  message, confirmText = "Confirmar", cancelText = "Cancelar",
  destructive = false, onConfirm, onCancel,
}: Props) {
  return (
    <Modal open={open} onClose={onCancel} title={title}>
      <p className="text-sm text-text mb-4 whitespace-pre-line">{message}</p>
      <div className="flex justify-end gap-2">
        <Button variant="ghost" onClick={onCancel}>{cancelText}</Button>
        <Button variant={destructive ? "danger" : "primary"} onClick={onConfirm}>{confirmText}</Button>
      </div>
    </Modal>
  );
}
